import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { RulesEditorActivatableSection } from "./rules-editor-activatable-section";
import RulesEditorDeviceConfigSectionOpen from "./rules-editor-device-config-section-open";

export interface RulesEditorDeviceConfigSectionProps {
	className?: string;
	config: string | null;
	onChangeConfig: (config: string | null) => void;
	error?: boolean;
	disabled?: boolean;
	disabledTooltip?: string;
}

export default function RulesEditorDeviceConfigSection(
	props: RulesEditorDeviceConfigSectionProps,
) {
	const { t } = useTranslation();
	const onChangeConfig = props.onChangeConfig;

	const openSettings = useCallback(() => {
		onChangeConfig("");
	}, [onChangeConfig]);

	const closeSettings = useCallback(() => {
		onChangeConfig(null);
	}, [onChangeConfig]);

	if (props.config === null) {
		return (
			<RulesEditorActivatableSection
				className={props.className}
				title={t("rules.editor.device_config.title")}
				onActivate={props.disabled ? undefined : openSettings}
				disabled={props.disabled}
				disabledTooltip={props.disabledTooltip}
			/>
		);
	} else {
		return (
			<RulesEditorDeviceConfigSectionOpen
				className={props.className}
				config={props.config}
				onChangeConfig={props.onChangeConfig}
				error={props.error}
				onClose={closeSettings}
				disabled={props.disabled}
				disabledTooltip={props.disabledTooltip}
			/>
		);
	}
}
